import React from "react";
import {Container} from "@chakra-ui/react";

function Advantage(props) {
    return (
        <Container
            maxW={'7xl'}
            paddingX={0}
            marginY={4}
            paddingY={6}
            minH={'40vh'}
            backgroundColor={"moccasin"}
            zIndex={25}
        >

        </Container>
    );
}

export default Advantage;
